    var Imgarr = [
      [
        [
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/1_2e7bdf40-030d-492d-a38a-b3c808433ab4.jpg?v=1737511198&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/2_ef3d720b-bc2a-4643-9758-761cddcbf561.jpg?v=1737511199&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/3_460598e0-5233-49ba-80a1-fd099359fe82.jpg?v=1737511199&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/4_676b5e40-d5bf-4ff5-b11d-8926054105b6.jpg?v=1737511199&width=1946',
        ],
        [
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/5_b62b8dd9-add3-498b-8e8c-b1ce73e4c434.jpg?v=1737511199&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/6_feb8d18a-ee66-43e5-8e07-21f03159a9e8.jpg?v=1737511199&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/7_12abe1a7-01dd-4eba-b5fa-3cb620f9b19d.jpg?v=1737511199&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/8_7abc887b-5466-4f4a-914c-df709f03f22c.jpg?v=1737511199&width=1946',
        ],
      ],
      [
        [
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/1_83001820-1f35-4791-a750-7fdea81fa767.jpg?v=1737512012&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/2_a84642e7-62a3-4418-b66a-e5d533c3b6f6.jpg?v=1737511213&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/3_3e405e52-3db1-4d0b-bda4-43b464934bad.jpg?v=1737511213&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/4_9c8f1d78-cd93-4209-87aa-7a8b7b65c913.jpg?v=1737511213&width=1946',
        ],
        [
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/5_b6f93698-34af-4fd0-8610-f146626031e4.jpg?v=1737511213&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/6_f81a46ca-9f0b-4270-951a-ff043a99aa2c.jpg?v=1737511213&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/7_4f2b0bfe-74a2-411a-ad6b-1b6d8801f46d.jpg?v=1737511213&width=1946',
          'https://cdn.shopify.com/s/files/1/0644/4495/6903/files/8_dc8bbf1b-c33e-40e6-92d1-06bde0c8d2db.jpg?v=1737511213&width=1946',
        ],
      ],
    ]
function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 倒计时
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    let prods = window.product

    // 动画
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
      }
    }, 1000)
    // 图片集合

    // 数字框
    function getCur(){
      let color = $('#color div.active').attr('data-val')
      let size = $('#Size div.active').attr('data-val')
      let num = $('#num div.active').text()
      return prods.filter(item=> item.option1 == color && item.option2 == size&&item.option3 == num)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('.price1').html(price)
      $('.price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".sp-part5 .sp-save .off_box").html(off_font);

      if (price <= 50) {
        $('.sp-shoppings').css('display', 'none')
      } else {
        $('.sp-shoppings').css('display', 'flex')
      }
    }
    $('.mySwiper div').click(function(){
      changePrice()
    })
    $('.sp-btn-style').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    if (window.cartCount > 0) {
      $('.sp-cart .num').css('background', '#cf0101')
    } else {
      $('.sp-cart .num').css('background', '#919191')
    }
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })
    // 弹窗 图片
    $('.option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changePrice()
    })

    // style选项
    let typeOptions = $('.option')

    typeOptions.click(function () {
      changSwiper()
    })
    function changSwiper() {
      var index = $('#color .option.active').index()
      var index2 = $('#Size .option.active').index()
      var index3 = $('#num .option.active').index()
      $(".product_img").attr("src",Imgarr[index][index2][index3])
    }
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 加入购物车
    $('.product-part .cart-btn').click(function () {
      var img = $('<img src="' + $(".product_img").attr("src") + '" alt="">')
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            if (result.item_count > 0) {
              $('.sp-cart .num').css('background', '#cf0101')
            } else {
              $('.sp-cart .num').css('background', '#919191')
            }
          });
        },
        dataType: "json",
      });

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')
      var offset = $('.sp-cart')[0].getBoundingClientRect()
      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: '692px',
        height: '547px',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '9999',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          top: finish[0].offsetTop + 120,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
          'z-index': '9999',
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $('.sp-header-top .sp-cart').addClass('sp-shake')
              setTimeout(function () {
                $('.sp-header-top .sp-cart').removeClass('sp-shake')
              }, 400)
              $(this).detach()
            }
          )
        }
      )
    })
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    preloadImages(Imgarr)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop 
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
